module.exports = __webpack_public_path__ + "img/ml3057.fdee4148.png";